export default {
  API_URI: '/api/v1/iph',
  ASSETS_PROFILE_IMAGES() {
    return `${process.env.VUE_APP_BASE_URL}/assets/avatar_perfil/`
  },
}
